import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { useBKJComboBoxContext } from './BKJComboBox.context.js';
import { BKJComboBoxItem } from './BKJComboBoxItem.js';
import i18next from 'i18next';
// WEB-4811 / FR-005a: zero-results placeholder. Direct <li role="option"
// aria-disabled="true"> — intentionally NOT routed through BKJComboBoxItem
// so Downshift's getItemProps is not called for it. It is a live, AT-
// announceable child of role="listbox" but NOT a selectable option and NOT
// addressable by aria-activedescendant.
const noResultsStyle = {
    padding: '12px 16px',
    color: '#6b6b6b',
    fontStyle: 'italic',
    pointerEvents: 'none',
};
export const BKJComboBoxOptionsMapper = ({ overrides, }) => {
    const { options, rowVirtualizer } = useBKJComboBoxContext();
    return (_jsxs(Fragment, { children: [_jsx("li", { style: { height: rowVirtualizer.totalSize } }, "total-size"), options.length > 0 ? (rowVirtualizer.virtualItems.map((virtualRow) => {
                const item = options[virtualRow.index];
                return (_jsx(BKJComboBoxItem, { ...item, overrides: overrides, index: virtualRow.index, style: {
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: virtualRow.size,
                        transform: `translateY(${virtualRow.start}px)`,
                        ...(item.groupId && !item.isGroupNode && { paddingLeft: '42px' }),
                    } }, options[virtualRow.index].id));
            })) : (
            // role="option" on <li> is the WAI-ARIA APG-specified shape for a
            // non-selectable child of a role="listbox" parent (spec FR-005a).
            // The jsx-a11y strict preset flags any interactive role on a non-
            // interactive element without considering the listbox-child context,
            // which is why this line needs an exception.
            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
            _jsx("li", { role: "option", "aria-disabled": "true", "aria-selected": "false", style: noResultsStyle, children: i18next.t('translations:NO_RESULTS') }))] }));
};
//# sourceMappingURL=BKJComboBoxOptionsMapper.js.map